import type { ComponentProps, PropsWithChildren } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { SizeProps } from 'styled-system';
import {
  backgroundColor,
  borderRadius,
  color,
  display,
  fontSize,
  lineHeight,
  size,
  textAlign,
  verticalAlign,
} from 'styled-system';

interface BadgeProps extends PropsWithChildren, SizeProps {
  className?: string;
}

const SIZE = '18px';

const UnstyledStyledBadge = styled.span<any>`
  ${size};
  ${display};
  ${fontSize};
  ${lineHeight};
  ${color};
  ${textAlign};
  ${verticalAlign};
  ${backgroundColor};
  ${borderRadius};
`;

const StyledBadge = (props: ComponentProps<typeof UnstyledStyledBadge>) => (
  <UnstyledStyledBadge
    display="block"
    fontSize="10px"
    lineHeight={SIZE}
    color="sys.neutral.background.default"
    textAlign="center"
    verticalAlign="middle"
    backgroundColor="sys.primary.background.default"
    borderRadius="circle"
    size={props.size || SIZE}
    {...props}
  />
);

const CountBadge = ({ className, children, size: sizeProp = SIZE }: BadgeProps) => (
  <StyledBadge className={className} data-testid="count-badge" size={sizeProp}>
    {children}
  </StyledBadge>
);

export default CountBadge;
